import { FC, ReactNode, createContext, useState } from 'react'

export interface DisableContext {
  disabled?: boolean
  disable: () => void
  enable: () => void
}

export const ACTIVE_CONTEXT = {
  disabled: false,
  disable: () => {
    /* do nothing */
  },
  enable: () => {
    /* do nothing */
  },
}

export const useDisabled = () => {
  const [disabled, setDisabled] = useState(false)

  const disable = () => {
    setDisabled(true)
  }

  const enable = () => {
    setDisabled(false)
  }

  return {
    disabled,
    disable,
    enable,
  } as DisableContext
}

export const DisabledContext = createContext<DisableContext>(ACTIVE_CONTEXT)

interface DisablingProviderProps {
  children: ReactNode
}
export const DisablingProvider: FC<DisablingProviderProps> = ({ children }) => {
  return <DisabledContext.Provider value={useDisabled()}>{children}</DisabledContext.Provider>
}
